module.exports = __webpack_public_path__ + "static/media/menu-2.355c5da2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/menu-2.svg
// module id = 1187
// module chunks = 0